var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { staticClass: "pb-0 pt-0 h-100", attrs: { fluid: "" } },
    [
      _c(
        "v-row",
        { staticClass: "h-100" },
        [
          _c(
            "v-col",
            { staticClass: "pa-0 h-100", attrs: { cols: "12" } },
            [
              _c(
                "v-card",
                {
                  staticClass: "h-100 d-flex flex-column",
                  attrs: {
                    elevation: _vm.embedded ? 0 : 2,
                    elevation: "0",
                    outlined: "",
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "d-flex align-center justify-content-between pl-3",
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "d-flex" },
                        [
                          _vm.report.playerId
                            ? _c("img", {
                                staticClass: "rounded-lg",
                                attrs: {
                                  src:
                                    "https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/faces/" +
                                    _vm.report.playerId +
                                    ".png",
                                  height: "45px",
                                  contain: "",
                                },
                                on: {
                                  error: function ($event) {
                                    return _vm.onImageLoadFailure(
                                      $event,
                                      "player"
                                    )
                                  },
                                },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.report.playerId
                            ? _c(
                                "v-icon",
                                { attrs: { large: "", color: "primary" } },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.getIconByPetition(_vm.report.petition)
                                    )
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "v-icon",
                            {
                              staticClass: "ml-n4 mt-9",
                              attrs: { color: "secondary" },
                            },
                            [_vm._v("assignment")]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "flex-grow-1" },
                        [
                          _c("v-card-title", [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "d-flex align-center justify-space-between w-100",
                              },
                              [
                                _c(
                                  "router-link",
                                  {
                                    staticClass: "nav-link",
                                    attrs: {
                                      to: `/report/${_vm.report.reportId}`,
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "d-flex",
                                        style: {
                                          "max-width":
                                            _vm.embedded ||
                                            _vm.$vuetify.breakpoint.mdAndDown
                                              ? "155px"
                                              : "auto",
                                        },
                                      },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "text-ellipsis" },
                                          [
                                            _vm._v(
                                              "\n                      " +
                                                _vm._s(
                                                  _vm.report.petition ===
                                                    "Deep Report"
                                                    ? _vm.report.playerName
                                                    : _vm.$t(
                                                        `requestReport.categories.${_vm.report.petition.toLowerCase()}.title`
                                                      )
                                                ) +
                                                "\n                    "
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-tooltip",
                                          {
                                            attrs: {
                                              top: "",
                                              color: "lightSecondary lighten-4",
                                              "max-width": "300",
                                            },
                                            scopedSlots: _vm._u([
                                              {
                                                key: "activator",
                                                fn: function ({ on }) {
                                                  return [
                                                    _vm.report.isSupervised
                                                      ? _c(
                                                          "v-icon",
                                                          _vm._g(
                                                            {
                                                              staticClass:
                                                                "ml-3",
                                                              attrs: {
                                                                color:
                                                                  "secondary",
                                                              },
                                                            },
                                                            on
                                                          ),
                                                          [_vm._v("visibility")]
                                                        )
                                                      : _vm._e(),
                                                  ]
                                                },
                                              },
                                            ]),
                                          },
                                          [
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "black--text body-1",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "collections.privacity.supervisedDescription"
                                                    )
                                                  ) + " "
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-tooltip",
                                          {
                                            attrs: {
                                              top: "",
                                              color: "lightSecondary lighten-4",
                                              "max-width": "300",
                                            },
                                            scopedSlots: _vm._u([
                                              {
                                                key: "activator",
                                                fn: function ({ on }) {
                                                  return [
                                                    _vm.report.isPublic
                                                      ? _c(
                                                          "v-icon",
                                                          _vm._g(
                                                            {
                                                              staticClass:
                                                                "ml-3",
                                                              attrs: {
                                                                color:
                                                                  "secondary",
                                                              },
                                                            },
                                                            on
                                                          ),
                                                          [_vm._v("public")]
                                                        )
                                                      : _vm._e(),
                                                  ]
                                                },
                                              },
                                            ]),
                                          },
                                          [
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "black--text body-1",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "collections.privacity.publicDescription"
                                                    )
                                                  ) + " "
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _vm.report.petition === "Deep Report" &&
                                !_vm.embedded
                                  ? _c(
                                      "v-btn",
                                      {
                                        attrs: {
                                          outlined: "",
                                          color: "secondary",
                                          "x-small": "",
                                          to: `/player/${_vm.report.playerId}`,
                                        },
                                      },
                                      [
                                        _c("v-icon", { attrs: { small: "" } }, [
                                          _vm._v("remove_red_eye"),
                                        ]),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ]),
                          _vm._v(" "),
                          _c("v-card-subtitle", [
                            !_vm.userHasRole("ROLE_ADMIN")
                              ? _c(
                                  "div",
                                  { staticClass: "d-flex" },
                                  [
                                    _c(
                                      "v-chip",
                                      {
                                        staticClass: "white--text",
                                        attrs: {
                                          "x-small": "",
                                          color: _vm.getCircleColorByState(
                                            _vm.report.stateId
                                          ),
                                          "text-color": "white",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              _vm.$t(_vm.report.stateCode)
                                            ) +
                                            "\n                "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.userHasRole("ROLE_ADMIN")
                              ? _c(
                                  "div",
                                  { staticClass: "state-selector" },
                                  [
                                    _c("v-select", {
                                      attrs: {
                                        items: _vm.states,
                                        "hide-details": "",
                                        flat: "",
                                        outlined: "",
                                        solo: "",
                                        dense: "",
                                        "item-value": "id",
                                        "item-text": "descEng",
                                        height: "25px",
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.onStateChange($event)
                                        },
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "selection",
                                            fn: function ({ item }) {
                                              return [
                                                _c(
                                                  "v-chip",
                                                  {
                                                    staticClass: "white--text",
                                                    attrs: {
                                                      "x-small": "",
                                                      color:
                                                        _vm.getCircleColorByState(
                                                          item.id
                                                        ),
                                                      "text-color": "white",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                      " +
                                                        _vm._s(
                                                          _vm.$t(item.desEng)
                                                        ) +
                                                        "\n                    "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            },
                                          },
                                          {
                                            key: "item",
                                            fn: function (data) {
                                              return [
                                                _c(
                                                  "span",
                                                  { staticClass: "body-2" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(data.item.desEng)
                                                      )
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "v-icon",
                                                  {
                                                    staticClass: "ml-1",
                                                    attrs: {
                                                      small: "",
                                                      color:
                                                        _vm.getCircleColorByState(
                                                          data.item.id
                                                        ),
                                                    },
                                                  },
                                                  [_vm._v("album")]
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        false,
                                        3405843565
                                      ),
                                      model: {
                                        value: _vm.report.stateId,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.report, "stateId", $$v)
                                        },
                                        expression: "report.stateId",
                                      },
                                    }),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.onNavigateReportClick()
                            },
                          },
                        },
                        [
                          _c(
                            "router-link",
                            {
                              staticClass: "pr-3 cursor-pointer",
                              attrs: { to: `/report/${_vm.report.reportId}` },
                            },
                            [
                              _vm.report.newMessages &&
                              _vm.report.newMessages.length
                                ? _c(
                                    "v-badge",
                                    {
                                      attrs: {
                                        color: "red",
                                        content: _vm.report.newMessages.length,
                                        overlap: "",
                                      },
                                    },
                                    [
                                      _c(
                                        "v-icon",
                                        { attrs: { color: "secondary" } },
                                        [_vm._v("message")]
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              !(
                                _vm.report.newMessages &&
                                _vm.report.newMessages.length
                              )
                                ? _c(
                                    "v-icon",
                                    { attrs: { color: "secondary" } },
                                    [_vm._v("message")]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("v-divider"),
                  _vm._v(" "),
                  _c(
                    "v-card-text",
                    {
                      staticClass: "primary--text flex-grow-1",
                      staticStyle: { padding: "16px" },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "d-flex justify-space-between" },
                        [
                          _c("span", { staticClass: "subheader-font" }, [
                            _vm._v(_vm._s(_vm.$t("reports.requestAt"))),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "monospace-font" }, [
                            _vm._v(_vm._s(_vm.report.createdAt)),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _vm.showCreator
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "d-flex justify-space-between body-2 mt-n1 pt-1",
                            },
                            [
                              _c("span", { staticClass: "subheader-font" }, [
                                _vm._v(_vm._s(_vm.$t("general.by"))),
                              ]),
                              _vm._v(" "),
                              _c("span", { staticClass: "font-weight-bold" }, [
                                _vm._v(_vm._s(_vm.report.userName)),
                              ]),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.userHasRole("ROLE_ADMIN") || _vm.report.clientName
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "d-flex justify-space-between body-2 mt-n1 pt-1",
                            },
                            [
                              _c("span", { staticClass: "subheader-font" }, [
                                _vm._v(_vm._s(_vm.$t("general.client"))),
                              ]),
                              _vm._v(" "),
                              _c("span", { staticClass: "subheader-font" }, [
                                _vm._v(_vm._s(_vm.report.clientName)),
                              ]),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.report.petition === "Deep Report"
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "d-flex flex-column justify-space-between mt-2",
                            },
                            [
                              _c("span", { staticClass: "subheader-font" }, [
                                _vm._v(_vm._s(_vm.$t("reports.features"))),
                              ]),
                              _vm._v(" "),
                              _c(
                                "ul",
                                {
                                  staticClass:
                                    "font-weight-medium primary--text body-2",
                                },
                                [
                                  _vm.report.isPerformance
                                    ? _c("li", [
                                        _vm._v(
                                          _vm._s(_vm.$t("reports.performance"))
                                        ),
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.report.isEvolution
                                    ? _c("li", [
                                        _vm._v(
                                          _vm._s(_vm.$t("reports.evolution"))
                                        ),
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.report.isCompareMyTeam
                                    ? _c("li", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("reports.compareWithMyTeam")
                                          )
                                        ),
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.report.isSimilarPlayers
                                    ? _c("li", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("reports.similarPlayers")
                                          )
                                        ),
                                      ])
                                    : _vm._e(),
                                ]
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.report.notes || _vm.report.petition === "Deep Report"
                        ? _c(
                            "div",
                            {
                              staticStyle: {
                                "margin-top": "8px",
                                "margin-bottom": "8px",
                                "margin-left": "-16px",
                                "margin-right": "-16px",
                                width: "calc(100% + 32px)",
                              },
                            },
                            [_c("v-divider")],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.report.notes
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "d-flex flex-column justify-space-between mt-2",
                            },
                            [
                              _c("span", { staticClass: "subheader-font" }, [
                                _vm._v(_vm._s(_vm.$t("general.notes"))),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "mt-1" }, [
                                _vm._v(_vm._s(_vm.report.notes)),
                              ]),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "d-flex flex-column justify-space-between mt-2",
                        },
                        [
                          _c("span", { staticClass: "subheader-font" }, [
                            _vm._v(_vm._s(_vm.$t("settings.language"))),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "d-flex align-center mt-1" },
                            [
                              _c("DriblabCountryFlag", {
                                attrs: {
                                  size: "small",
                                  iso:
                                    _vm.report.langName === "EN"
                                      ? "gb"
                                      : _vm.report.langName.toLowerCase(),
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "small",
                                { staticClass: "primary--text mx-2" },
                                [_vm._v(_vm._s(_vm.report.langName))]
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _vm.report.stateId === 3 && _vm.report.filename
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "d-flex justify-space-between body-2 mt-2",
                            },
                            [
                              _c("span", { staticClass: "subheader-font" }, [
                                _vm._v(_vm._s(_vm.$t("general.updated"))),
                              ]),
                              _vm._v(" "),
                              _c("span", { staticClass: "monospace-font" }, [
                                _vm._v(_vm._s(_vm.report.updatedAt)),
                              ]),
                            ]
                          )
                        : _vm._e(),
                    ]
                  ),
                  _vm._v(" "),
                  !_vm.embedded ? _c("v-divider") : _vm._e(),
                  _vm._v(" "),
                  _vm.report.stateId === 3 &&
                  _vm.report.filename &&
                  !_vm.userHasRole("ROLE_ADMIN")
                    ? _c("v-card-actions", { staticClass: "pa-3" }, [
                        _c(
                          "div",
                          { staticClass: "w-100 d-flex justify-center" },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "pa-2",
                                staticStyle: {
                                  "background-color": "rgba(0, 0, 0, 0.03)",
                                  "border-radius": "8px",
                                },
                              },
                              [
                                _c(
                                  "v-btn",
                                  {
                                    staticClass: "elevation-0 monospace-font",
                                    attrs: {
                                      color: "primary",
                                      small: "",
                                      loading: _vm.loadingFile,
                                      rounded: "",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.onDownloadClick()
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "v-icon",
                                      {
                                        staticClass: "mr-2",
                                        attrs: { small: "" },
                                      },
                                      [_vm._v("file_download")]
                                    ),
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(_vm.$t("general.download")) +
                                        "\n              "
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.userHasRole("ROLE_ADMIN")
                    ? _c(
                        "v-card-actions",
                        {
                          staticClass: "d-flex align-end pa-3",
                          staticStyle: { "min-height": "64px" },
                        },
                        [
                          _vm.report.filename
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "file-detail d-flex align-center pa-2",
                                  staticStyle: {
                                    "background-color": "rgba(0, 0, 0, 0.03)",
                                    "border-radius": "8px",
                                  },
                                },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      attrs: { color: "secondary" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.onDownloadClick()
                                        },
                                      },
                                    },
                                    [_vm._v("file_download")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      staticClass: "mx-2 body-1",
                                      on: {
                                        click: function ($event) {
                                          return _vm.onDownloadClick()
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.report.filename.replace(
                                            ".pdf",
                                            ""
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  !_vm.embedded
                                    ? _c(
                                        "v-icon",
                                        {
                                          attrs: { small: "", color: "error" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.onDeleteFileClick(
                                                _vm.report
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v("delete_forever")]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.report.filename
                            ? _c(
                                "div",
                                { staticClass: "file-selector" },
                                [
                                  _c("v-file-input", {
                                    staticClass: "d-flex align-center",
                                    attrs: {
                                      "hide-details": "",
                                      "prepend-icon": "attach_file",
                                      flat: "",
                                      solo: "",
                                      dense: "",
                                      height: "25px",
                                      loading: _vm.report.loadingFile,
                                      disabled: _vm.report.loadingFile,
                                      placeholder: _vm.$t("general.uploadFile"),
                                    },
                                    on: {
                                      change: function ($event) {
                                        return _vm.onFileChange(
                                          _vm.report,
                                          $event
                                        )
                                      },
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }